export const redactCharacter = '█'

// A redacted value is the original text replaced character for character. Empty text cannot be
// logically anonymized, so it never counts as redacted.
export const isTextFullyAnonymized = (text: string) =>
  text.length > 0 && text === redactCharacter.repeat(text.length)
